import React, {useState} from 'react';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import ContactUsNav from '@components/ContactUs/ContactUsNav';
import ContactUsTNH from '@components/ContactUs/ContactUsTNH';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
export default function ContactUs(props) {
    const {locale} = useRouter();
    return (
        <div>
            <SlideBanner titleBanner={getLocaleContent(locale, 'page.contact-us.title_nav')} />
            <ContactUsNav />
            <ContactUsTNH />
        </div>
    );
}

ContactUs.PageName = 'CONTACT-US';
